import { render } from "./MainBanners.vue?vue&type=template&id=71a543ac"
import script from "./MainBanners.vue?vue&type=script&lang=js"
export * from "./MainBanners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__